(()=> {
    if (!customElements.get('accordion-section')){
        class AccordionSection extends HTMLElement {
            connectedCallback() {
              this.addEventListeners();
            }
            addEventListeners() {
              this.querySelectorAll(".accordions-heading").forEach((heading, index) => {
                if (index === 0){
                    if (heading.parentElement.classList.contains('open')){
                        const content = heading.parentElement.querySelector(".accordions-content");
                        content.style.maxHeight = content.scrollHeight + "px";
                    }
                }
                heading.addEventListener("click", this.toggleAccordions.bind(heading));
              });
            }

            toggleAccordions(){
                const parent = this.parentElement;
                  const content = parent.querySelector(".accordions-content");
                  parent.classList.toggle("open");
                  if (!parent.classList.contains("open")) {
                    content.style.maxHeight = "0";
                  } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                }
            }
        }
        customElements.define("accordion-section", AccordionSection);
    }
})();